import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import ShowDashBoard from "../compoment/Dashboard/ShowDashBoard";
import Accueil from "../pages/Accueil";
import User from "../pages/User";
import Profil from "../pages/Profil";

import Page404 from "../pages/Page404";
import DetailUser from "../pages/DetailUser";
import { RequireAuth } from "../compoment/RequireAuth";
import { Permission } from "../compoment/Permission";
import ForgetPassword from "../pages/ForgetPassword";
import ResetPassword from "../pages/ResetPassword";
import ListeTypes from "../pages/TypesBien/ListeTypes";
import DetailTypes from "../pages/TypesBien/DetailTypes";
import CreateTypes from "../pages/TypesBien/CreateTypes";
import FactureCreate from "../pages/Facture/FactureCreate";
import FactureDetail from "../pages/Facture/FactureDetail";

import FactureList from "../pages/Facture/FactureList";
import EditFactures from "../pages/Facture/EditFactures";
import DetailFactureByDetailUser from "../pages/Facture/DetailFactureByDetailUser";
import ListerPaiement from "../pages/Paiements/ListerPaiement";
import DetailPaiements from "../pages/Paiements/DetailPaiements";
import CreatePaiements from "../pages/Paiements/CreatePaiements";
import RoleCreate from "../pages/roles/RoleCreate";
import CouponsDetail from "../pages/roles/CouponsDetail";
import RolesListe from "../pages/roles/CouponsRoles";
import ListeBiens from "../pages/biens/ListeBiens";
import BiensLocation from "../pages/biens/BiensLocation";
import BiensVendus from "../pages/biens/BiensVendus";
import BiensIndisponible from "../pages/biens/ListeInactifs";
import CreateProduit from "../pages/biens/CreateBiens";
import DetailBiens from "../pages/biens/DetailBiens";
import EditBiens from "../pages/biens/EditBiens";
import VilleCreate from "../pages/cities/VilleCreate";
import DetailCity from "../pages/cities/DetailCity";
import VilleListe from "../pages/cities/VilleListe";
import ListCommune from "../pages/communes/ListCommune";
import SaveCommune from "../pages/communes/SaveCommune";
import DetailCommune from "../pages/communes/DetailCommune";
import ListeCategorie from "../pages/categorie/ListeCategorie";
import CreateCategorie from "../pages/categorie/CreateCategorie";
import ListeClients from "../pages/clients/ListeClients";
import DetailClient from "../pages/clients/DetailClient";
import Statistique from "../pages/statistique/Statistique";
import ListContrat from "../pages/Contrats/ListContrat";
import CreateContrat from "../pages/Contrats/CreateContrat";
import ContratsDetail from "../pages/Contrats/ContratsDetail";
import DetailPaymentByFacture from "../pages/Contrats/DetailPaymentByFacture";
import ListePersonnel from "../pages/Personnel/ListePersonnel";
import CreatePersonnel from "../pages/Personnel/CreatePersonnel";
import DetailPersonnels from "../pages/Personnel/DetailPersonnels";
import EditerPersonnel from "../pages/Personnel/EditerPersonnel";
import NoteAndAvis from "../pages/Personnel/NoteAndAvis";
import ReclamationsView from "../pages/reclamations/ReclamationsView";
import ReclamationDetails from "../pages/reclamations/ReclamationDetails";
import Refused from "../pages/Refused";
import ListeProprietaire from "../pages/clients/Proprietaires/ListeProprietaire";
import CreateProprietaire from "../pages/clients/Proprietaires/CreateProprietaire";
import DetailProprietaire from "../pages/clients/Proprietaires/DetailProprietaire";
import ListRequete from "../pages/Requetes/ListRequete";
import DetailRequete from "../pages/Requetes/DetailRequete";
import Commodite from "../pages/commodite/Commodite";
import CreateCommodite from "../pages/commodite/CreateCommodite";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <Page404 />,
  },

  {
    path: "mot-de-passe-oublie",
    element: <ForgetPassword />,
  },

  {
    path: "changer-password/:email/:token",
    element: <ResetPassword />,
  },

  {
    path: "",
    element: (
      <RequireAuth>
        <ShowDashBoard />
      </RequireAuth>
    ),
    children: [
      {
        path: "/tableau-bord",
        element: (
          <RequireAuth>
            {" "}
            <Accueil />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/refused",
        element: <Refused />,
      },
      {
        path: "/utilisateurs",
        element: (
          <RequireAuth>
            {/* <Permission permission={'utilisateurs'}> */} <User />{" "}
            {/* </Permission> */}
          </RequireAuth>
        ),
      },
      {
        path: "/Historique_paiement",
        element: (
          <RequireAuth>
            {/* <Permission permission={'Paiement'}> */} <ListerPaiement />{" "}
            {/* </Permission> */}
          </RequireAuth>
        ),
      },
      {
        path: "/Historique_paiement/:id",
        element: (
          <RequireAuth>
            {/* <Permission permission={'Paiement'}> */} <DetailPaiements />{" "}
            {/* </Permission> */}
          </RequireAuth>
        ),
      },
      {
        path: "/paiement-creation/:id",
        element: (
          <RequireAuth>
            {/* <Permission permission={'Paiement'}> */} <CreatePaiements />{" "}
            {/* </Permission> */}
          </RequireAuth>
        ),
      },

      {
        path: "/categories/254nbre",
        element: (
          <RequireAuth>
            {/* <Permission permission={'Configuration'}> */} <ListeCategorie />{" "}
            {/* </Permission> */}
          </RequireAuth>
        ),
      },
      {
        path: "/categories/creation",
        element: (
          <RequireAuth>
            {/* <Permission permission={'Configuration'}> */}{" "}
            <CreateCategorie /> {/* </Permission> */}
          </RequireAuth>
        ),
      },
      {
        path: "/biens",
        element: (
          <RequireAuth>
            {/* <Permission permission={'Lister Propriété'}> */} <ListeBiens />{" "}
            {/* </Permission> */}
          </RequireAuth>
        ),
      },
      {
        path: "/biens-location",
        element: (
          <RequireAuth>
            {/* <Permission permission={'Lister Propriété'}> */}{" "}
            <BiensLocation /> {/* </Permission> */}
          </RequireAuth>
        ),
      },
      {
        path: "/biens-vendus",
        element: (
          <RequireAuth>
            {/* <Permission permission={'Lister Propriété'}> */} <BiensVendus />{" "}
            {/* </Permission> */}
          </RequireAuth>
        ),
      },
      {
        path: "/biens_indisponible",
        element: (
          <RequireAuth>
            {/* <Permission permission={'Lister Propriété'}> */}{" "}
            <BiensIndisponible /> {/* </Permission> */}
          </RequireAuth>
        ),
      },

      {
        path: "/creation-bien",
        element: (
          <RequireAuth>
            {" "}
            <CreateProduit />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/proprietaire/bien/:id",
        element: (
          <RequireAuth>
            {" "}
            <CreateProduit />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/biens-detail/:id",
        element: (
          <RequireAuth>
            {" "}
            <DetailBiens />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/editer/biens/:id",
        element: (
          <RequireAuth>
            {" "}
            <EditBiens />{" "}
          </RequireAuth>
        ),
      },

      {
        path: "/reclamations/commandes",
        element: (
          <RequireAuth>
            {" "}
            <ReclamationsView />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/proprietaire/enregistrement",
        element: (
          <RequireAuth>
            {" "}
            <CreateProprietaire />{" "}
          </RequireAuth>
        ),
      },

      {
        path: "/reclamations/commandes/:id/detail/:type",
        element: (
          <RequireAuth>
            {" "}
            <ReclamationDetails />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/utilisateurs/:id",
        element: (
          <RequireAuth>
            {" "}
            <DetailUser />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/liste_types",
        element: (
          <RequireAuth>
            {" "}
            <ListeTypes />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/personnels",
        element: (
          <RequireAuth>
            {" "}
            <ListePersonnel />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/personnels/edit/:id",
        element: (
          <RequireAuth>
            {" "}
            <EditerPersonnel />{" "}
          </RequireAuth>
        ),
      },

      {
        path: "/profil/edit/:id",
        element: (
          <RequireAuth>
            {" "}
            <EditerPersonnel />{" "}
          </RequireAuth>
        ),
      },

      {
        path: "/proprietaire/edit/:id",
        element: (
          <RequireAuth>
            {" "}
            <EditerPersonnel />{" "}
          </RequireAuth>
        ),
      },

      {
        path: "/personnels/creation",
        element: (
          <RequireAuth>
            <Permission permission={"Enregistrer Personnel"}>
              {" "}
              <CreatePersonnel />{" "}
            </Permission>
          </RequireAuth>
        ),
      },

      {
        path: "/types",
        element: (
          <RequireAuth>
            {" "}
            <CreateTypes />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/commodites",
        element: (
          <RequireAuth>
            {" "}
            <Commodite />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/commodites/creation",
        element: (
          <RequireAuth>
            {" "}
            <CreateCommodite />{" "}
          </RequireAuth>
        ),
      },

      {
        path: "/types/:id",
        element: (
          <RequireAuth>
            {" "}
            <DetailTypes />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/proprietaire",
        element: (
          <RequireAuth>
            {" "}
            <ListeProprietaire />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/proprietaire/:id",
        element: (
          <RequireAuth>
            {" "}
            <DetailProprietaire />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/factures",
        element: (
          <RequireAuth>
            {" "}
            <FactureList />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/factures/editer/:id",
        element: (
          <RequireAuth>
            {" "}
            <EditFactures />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/contrats/creer-facture/:id",
        element: (
          <RequireAuth>
            {" "}
            <FactureCreate />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/factures/:id",
        element: (
          <RequireAuth>
            {" "}
            <FactureDetail />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/factures/paiement/:id",
        element: (
          <RequireAuth>
            {" "}
            <DetailPaymentByFacture />{" "}
          </RequireAuth>
        ),
      },

      {
        path: "/requetes",
        element: (
          <RequireAuth>
            {" "}
            <ListRequete />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/requetes/:id",
        element: (
          <RequireAuth>
            {" "}
            <DetailRequete />{" "}
          </RequireAuth>
        ),
      },

      {
        path: "/coupons",
        element: (
          <RequireAuth>
            {" "}
            <RolesListe />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/personnels/:id",
        element: (
          <RequireAuth>
            {" "}
            <DetailPersonnels />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/personnels/client/:name/:id",
        element: (
          <RequireAuth>
            {" "}
            <NoteAndAvis />{" "}
          </RequireAuth>
        ),
      },

      {
        path: "/creer-coupons",
        element: (
          <RequireAuth>
            {" "}
            <RoleCreate />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/coupons/:id",
        element: (
          <RequireAuth>
            {" "}
            <CouponsDetail />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/villes",
        element: (
          <RequireAuth>
            {" "}
            <VilleListe />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/save-city",
        element: (
          <RequireAuth>
            {" "}
            <VilleCreate />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/villes/:id",
        element: (
          <RequireAuth>
            {" "}
            <DetailCity />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/communes",
        element: (
          <RequireAuth>
            {" "}
            <ListCommune />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/save/communes",
        element: (
          <RequireAuth>
            {" "}
            <SaveCommune />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/municipalite/:id",
        element: (
          <RequireAuth>
            {" "}
            <DetailCommune />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/contrats",
        element: (
          <RequireAuth>
            {" "}
            <ListContrat />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/creation-contrat",
        element: (
          <RequireAuth>
            {" "}
            <CreateContrat />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/contrats/:id",
        element: (
          <RequireAuth>
            {" "}
            <ContratsDetail />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/clients/:id",
        element: (
          <RequireAuth>
            {" "}
            <DetailClient />{" "}
          </RequireAuth>
        ),
      },

      {
        path: "/clients",
        element: (
          <RequireAuth>
            {" "}
            <ListeClients />{" "}
          </RequireAuth>
        ),
      },
      {
        path: "/Contrats/detail-factures/:id",
        element: (
          <RequireAuth>
            {" "}
            <DetailFactureByDetailUser />{" "}
          </RequireAuth>
        ),
      },

      {
        path: "/statistique",
        element: (
          <RequireAuth>
            {" "}
            <Statistique />{" "}
          </RequireAuth>
        ),
      },

      {
        path: "profil",
        element: <Profil />,
      },
    ],
  },
]);

export default router;
